import React, { useEffect, useState } from 'react';
import '../css/Files.css';

const FilesPage = ({ preferredUsername, onClose }) => {
  const username = preferredUsername;
  const [files, setFiles] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const API_URL_FILE = process.env.REACT_APP_BACKEND_URL;

  const handleImageClick = (file) => {
    setSelectedImage(file.fileData);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await fetch(`${API_URL_FILE}/${username}/files`);
        if (response.ok) {
          const data = await response.json();
          setFiles(data);
        } else {
          // Handle error scenario
        }
      } catch (error) {
        // Handle error scenario
      }
    };

    fetchFiles();
  }, [username]);

  const filterFilesByDate = () => {
    if (startDate && endDate) {
      const filteredFiles = files.filter((file) => {
        const fileDate = new Date(file.starts);
        return fileDate >= startDate && fileDate <= endDate;
      });
      return filteredFiles;
    }
    return files;
  };

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name === 'startDate') {
      setStartDate(new Date(value));
    } else if (name === 'endDate') {
      setEndDate(new Date(value));
    }
  };

  const filteredFiles = filterFilesByDate();

  return (
    <div className="files-page">
    <div className="popup">
      <div className="popup-content">
        <h1>Αποθηκευμένες Εικόνες</h1>
        <div className="date-range-container">
          <label htmlFor="startDate">Από:</label>
          <input type="date" id="startDate" name="startDate" onChange={handleDateChange} />
          <label htmlFor="endDate">Έως:</label>
          <input type="date" id="endDate" name="endDate" onChange={handleDateChange} />
        </div>
        <div className="file-container">
          {/* Display the images */}
          {filteredFiles.map((file) => (
            file.fileData && file.fileName && (
              <div key={file.id} className="image-wrapper">
                <p>{file.starts}</p> {/* Display the date */}
                <img
                  src={`data:image/jpeg;base64,${file.fileData}`}
                  alt={file.fileName}
                  onClick={() => handleImageClick(file)}
                />
              </div>
            )
          ))}
        </div>
        <button className="close-button" onClick={onClose}>Κλείσιμο</button>
      </div>

      {/* Modal for full screen image */}
      {selectedImage && (
        <div className="modal">
          <button className="modal-close" onClick={handleCloseModal}>Κλείσιμο</button>
          <div className="modal-image-container">
            <img src={`data:image/jpeg;base64,${selectedImage}`} alt="Full Screen" className="modal-image" />
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default FilesPage;
